import $http from '../../axios-instance';

export async function getEstados({ commit, state }) {
    await $http.get('controles/8', state.ingreso)
        .then((response) => {
            commit('cargarEstados', response.data)
            
        })
        .catch((error) => {

        })

}

export async function Pruebas({ commit, state }) {
    
    

}

export async function addProducto({ commit, state }) {
    
    await $http.post('adm_productos/crear', state.selectedProduct)
        .then((response) => {
            Notification.success({
                title: 'Exito!',
                message: 'El producto ha sido creado',
                type: 'success',
                duration: 1500,
                customClass: 'notification-box',
            });
            commit('setProduct', response.data.data)
            state.error = false
        })
        .catch((error) => {
            MessageBox.alert(error.message, 'Error', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: 'Aceptar',
                type: 'error',
                customClass:'notification-error'
            })
            commit('productError', error.message)
        })

}

